__turbopack_context__.v({
  "addCartBtn": "GadgetProductCard-module__F_dV3G__addCartBtn",
  "brandName": "GadgetProductCard-module__F_dV3G__brandName",
  "card": "GadgetProductCard-module__F_dV3G__card",
  "discountBadge": "GadgetProductCard-module__F_dV3G__discountBadge",
  "image": "GadgetProductCard-module__F_dV3G__image",
  "imageWrap": "GadgetProductCard-module__F_dV3G__imageWrap",
  "info": "GadgetProductCard-module__F_dV3G__info",
  "name": "GadgetProductCard-module__F_dV3G__name",
  "newPrice": "GadgetProductCard-module__F_dV3G__newPrice",
  "oldPrice": "GadgetProductCard-module__F_dV3G__oldPrice",
  "outOfStockBtn": "GadgetProductCard-module__F_dV3G__outOfStockBtn",
  "priceRow": "GadgetProductCard-module__F_dV3G__priceRow",
  "quantityBtn": "GadgetProductCard-module__F_dV3G__quantityBtn",
  "quantityControl": "GadgetProductCard-module__F_dV3G__quantityControl",
  "quantityInput": "GadgetProductCard-module__F_dV3G__quantityInput",
});
